/* Twemoji — render flag emojis correctly on all platforms including Windows */
(function() {
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/twemoji@14.0.2/dist/twemoji.min.js';
  s.crossOrigin = 'anonymous';
  s.onload = function() {
    twemoji.parse(document.body, { folder: 'svg', ext: '.svg' });
  };
  document.head.appendChild(s);
})();
